import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import "../CSS/Grids.css";

export default function GridsCSS(props) {
  const [gridsToDraw, setGridsToDraw] = useState([]);
  const [gridType, setGridType] = useState("");

  useEffect(() => {
    setGridType(
      props.partName === "Roof"
        ? "_roof"
        : props.partName === "Rear_Header_Outer_Panel_Top_Side"
        ? "_rear"
        : props.partName === "Pillar_Lower_LH" ||
          props.partName === "Pillar_Lower_RH"
        ? "_pillerLower"
        : props.partName === "Top_Tail_Lamp_LH" ||
          props.partName === "Top_Tail_Lamp_RH"
        ? "_panelAssy"
        : props.partName === "z101Roof" ||
          props.partName === "Bottom_Tail_Lamps_LH_RH"
        ? "_z101Roof"
        : props.partName === "Hinge_Swing_Gate"
        ? "_swing"
        : ""
    );
  }, [props.partName]);

  useEffect(() => {
    const generateGrids = (rows, cols) =>
      Array.from({ length: rows }, () =>
        Array.from({ length: cols }, () => " ")
      );

    switch (gridType) {
      case "_roof":
        setGridsToDraw(generateGrids(6, 11));
        break;
      case "_rear":
        setGridsToDraw(generateGrids(4, 11));
        break;
        case "_pillerLower":
          setGridsToDraw(generateGrids(7, 10));
          break;
      case "_swing":
        setGridsToDraw(generateGrids(9, 6));
        break;
      case "_panelAssy":
        setGridsToDraw(generateGrids(9, 10));
        break;
      case "_z101Roof":
        setGridsToDraw(generateGrids(7, 11));
        break;
      default:
        setGridsToDraw(generateGrids(7, 12));
        break;
    }
  }, [gridType]);

  const highlightedCells = (props.highlightedCells || []).map((grid) => ({
    row: grid.row,
    col: grid.column,
  }));

  return (
    <>
      {gridsToDraw.map((row, rowIndex) => (
        <Row key={rowIndex} className={`row_height_css${gridType}`}>
          {row.map((cell, colIndex) => (
            <Col
              key={colIndex}
              xs={1}
              sm={1}
              md={1}
              lg={1}
              xl={1}
              xxl={1}
              className={
                highlightedCells.some(
                  (highlightedCell) =>
                    highlightedCell.row === rowIndex &&
                    highlightedCell.col === colIndex
                )
                  ? ""
                  : "highlighted"
              }
            >
              <div className="modified_row"> {cell} </div>
            </Col>
          ))}
        </Row>
      ))}
    </>
  );
}
